import { z } from 'zod';

/**
 * Scratch notes: a temporary feature to try the command bus, History and undo with real clicks.
 * Removed in P16 (a migration drops the table).
 */

export const NOTE_COMMANDS = ['note.create', 'note.update', 'note.delete', 'note.restore'] as const;

const title = z.string().trim().min(1, 'Give the note a title').max(120);
const body = z.string().max(5000);
const id = z.string().uuid();
const version = z.number().int().min(1);

export const noteCreateInput = z.strictObject({ title, body });
export const noteUpdateInput = z
  .strictObject({
    id,
    /** The version you were looking at. If someone changed it since, the change is refused. */
    expectedVersion: version,
    title: title.optional(),
    body: body.optional(),
  })
  .refine((v) => v.title !== undefined || v.body !== undefined, 'Nothing to change');
export const noteDeleteInput = z.strictObject({ id, expectedVersion: version });
export const noteRestoreInput = z.strictObject({ id, expectedVersion: version });

export const noteItemSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  body: z.string(),
  version: z.number().int(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
  /** Set by the background worker shortly after a note is created. */
  processedAt: z.iso.datetime().nullable(),
});
export type NoteItem = z.infer<typeof noteItemSchema>;
export const noteListSchema = z.object({ notes: z.array(noteItemSchema) });
